import axiosInstance from '../../axios-config';

const sendHealthSummaryApi = '/api/patients/{0}/HealthSummary/{1}/{2}?language={3}';
const filterHealthSummaryApi = '/api/patients/{0}/HealthSummary/{1}?startDate={2}&endDate={3}';
const healthSummaryHtmlApi = '/api/patients/{0}/HealthSummary/{1}/html';
const mostRecentHealthSummaryIdentifierApi = '/api/patients/{0}/MostRecentHealthSummary/{1}';
const healthSummaryDownloadApi = '/api/patients/{0}/HealthSummary/{1}/download';
const mostRecentOfficeVisitsApi = '/api/patients/{0}/HealthSummary/OfficeVisits';

export const filterHealthSummary = (patientId, params) =>
  axiosInstance.get(filterHealthSummaryApi
    .replace('{0}', patientId)
    .replace('{1}', params.ifSystemId)
    .replace('{2}', params.startDate)
    .replace('{3}', params.endDate));

export const sendHealthSummary = (params, languageCode) =>
  axiosInstance.post(sendHealthSummaryApi
    .replace('{0}', params.patientId)
    .replace('{1}', params.ifSystemId)
    .replace('{2}', params.transmitType)
    .replace('{3}', languageCode), params);

const buildIdentifierApiString = (apiBaseString, identifier) => {
  let queryString = '';
  let apiString = '';

  if (identifier.ccdaId !== null && identifier.ccdaId !== undefined) {
    queryString += 'ccdaId=' + identifier.ccdaId;
  }

  if (identifier.startDate !== null && identifier.startDate !== undefined) {
    if (queryString.length > 0) {
      queryString += '&';
    }
    queryString += 'startDate=' + identifier.startDate;
  }

  if (identifier.endDate !== null && identifier.endDate !== undefined) {
    if (queryString.length > 0) {
      queryString += '&';
    }
    queryString += 'endDate=' + identifier.endDate;
  }

  if (queryString.length > 0) {
    apiString = apiBaseString + '?' + queryString;
  }

  return apiString;
};

export const getHealthSummaryDownloadPath = (patientId, identifier, accessToken) => {
  let api = healthSummaryDownloadApi.replace('{0}', patientId).replace('{1}', identifier.ifSystemId);
  const apiUrl = window.equicareLocalConfiguration.apiUrl;
  let protocolHost = window.location.protocol + '//' + apiUrl.hostname;
  if (apiUrl.port !== null && apiUrl.port !== undefined && apiUrl.port !== '') {
    protocolHost = protocolHost + ':' + apiUrl.port;
  }
  api = buildIdentifierApiString(api, identifier);
  api = api + '&token=' + accessToken;
  api = protocolHost + api;
  return api;
};

export const getHealthSummaryHtml = (patientId, identifier) => {
  let api = healthSummaryHtmlApi.replace('{0}', patientId).replace('{1}', identifier.ifSystemId);
  api = buildIdentifierApiString(api, identifier);
  return axiosInstance.get(api);
};

export const getMostRecentHealthSummaryIdentifier = (patientId, ifSystemId) =>
  axiosInstance.get(mostRecentHealthSummaryIdentifierApi.replace('{0}', patientId).replace('{1}', ifSystemId));

export const getMostRecentOfficeVisitsForPatient = (patientId) =>
  axiosInstance.get(mostRecentOfficeVisitsApi.replace('{0}', patientId));
